import {Stack, styled} from '@mui/material';

export const StyledStack = styled(Stack)`
	gap: 12px;
`;

export const StyledContainer = styled(Stack)`
	gap: 8px;
`;
